import React, { PureComponent } from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
//Limitless imports
import SubmitButton from "../../forms/submit-button/SubmitButton";
class NewMessageFooter extends PureComponent {
  render() {
    const {
      classes,
      onButtonClick
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.container
    }, /*#__PURE__*/React.createElement(SubmitButton, {
      disabled: false,
      id: "newConversationButton",
      title: "New Conversation",
      handleSubmit: onButtonClick,
      loading: false,
      containerEnabled: false,
      staticButton: true
    }));
  }
}
const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "0 -2px 0 rgba(0, 0, 0, 0.04), 0 -1px 0 rgba(0, 0, 0, 0.06)",
    minHeight: 55
  }
};
export default withStyles(styles)(NewMessageFooter);
NewMessageFooter.propTypes = {
  classes: PropTypes.object.isRequired,
  onButtonClick: PropTypes.func.isRequired
};